// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c83de0a0","977":"1a3a257e"}[chunkId] + ".chunk.js";
};